var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Api, JsonRpc } from 'eosjs';
import * as EosLedger from './EosLedger';
import TransportU2F from '@ledgerhq/hw-transport-u2f';
import TransportWebAuthn from '@ledgerhq/hw-transport-webauthn';
import TransportWebBLE from '@ledgerhq/hw-transport-web-ble';
import LedgerDataManager from './LedgerDataManager';
import 'babel-polyfill';
import * as ecc from 'eosjs-ecc';
import * as bigi from 'bigi';
// import {discoveryOptions} from './types';
// https://github.com/LedgerHQ/ledgerjs/issues/266
// https://github.com/JoinColony/purser/issues/184
var history_get_key_accounts_result = /** @class */ (function () {
    function history_get_key_accounts_result() {
    }
    return history_get_key_accounts_result;
}());
var LedgerProxy = /** @class */ (function () {
    function LedgerProxy(exchangeTimeout, supplied_transport) {
        this._exchangeTimeout = exchangeTimeout;
        this.transport = supplied_transport;
    }
    ;
    LedgerProxy.prototype.getPathKeys = function (keyPositions) {
        return __awaiter(this, void 0, void 0, function () {
            var eos, keys, _i, keyPositions_1, num, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eos = new EosLedger.default(this.transport);
                        keys = [];
                        _i = 0, keyPositions_1 = keyPositions;
                        _a.label = 1;
                    case 1:
                        if (!(_i < keyPositions_1.length)) return [3 /*break*/, 4];
                        num = keyPositions_1[_i];
                        return [4 /*yield*/, eos.getAddress("44'/194'/0'/0/" + num)];
                    case 2:
                        result = _a.sent();
                        //keys[num] = result.address;
                        keys.push({ index: num, key: result.address });
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, keys];
                }
            });
        });
    };
    LedgerProxy.prototype.sign = function (toSign, index) {
        return __awaiter(this, void 0, void 0, function () {
            var eos, signatures, toSignHex, signedTxn, si;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eos = new EosLedger.default(this.transport, this._exchangeTimeout);
                        signatures = [''];
                        toSignHex = toSign.toString('hex');
                        return [4 /*yield*/, eos.signTransaction("44'/194'/0'/0/" + index, toSignHex)];
                    case 1:
                        signedTxn = _a.sent();
                        si = new ecc.Signature(bigi.fromHex(signedTxn.r), bigi.fromHex(signedTxn.s), bigi.fromHex(signedTxn.v));
                        return [2 /*return*/, si.toString()];
                }
            });
        });
    };
    return LedgerProxy;
}());
export function ledgerWalletProvider(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.id, id = _c === void 0 ? 'ledger' : _c, _d = _b.name, name = _d === void 0 ? 'Ledger Nano S' : _d, _e = _b.shortName, shortName = _e === void 0 ? 'Ledger Nano S' : _e, _f = _b.description, description = _f === void 0 ? 'Use Ledger Nano S hardware wallet to sign your transactions' : _f, _g = _b.exchangeTimeout, exchangeTimeout = _g === void 0 ? 10000 : _g, _h = _b.transport, transport = _h === void 0 ? 'TransportU2F' : _h;
    return function makeWalletProvider(network) {
        var rpc = new JsonRpc(network.protocol + '://' + network.host + ':' + network.port);
        // let keys: string[] = [];
        var selectedIndex = -1;
        var selectedIndexArray = [];
        var keyMap = [];
        var ledger;
        var selectedTransport;
        function connect(appName) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(transport === 'TransportWebAuthn')) return [3 /*break*/, 2];
                            return [4 /*yield*/, TransportWebAuthn.create()];
                        case 1:
                            selectedTransport = _a.sent();
                            return [3 /*break*/, 6];
                        case 2:
                            if (!(transport === 'TransportWebBLE')) return [3 /*break*/, 4];
                            return [4 /*yield*/, TransportWebBLE.create()];
                        case 3:
                            selectedTransport = _a.sent();
                            return [3 /*break*/, 6];
                        case 4: return [4 /*yield*/, TransportU2F.create()];
                        case 5:
                            selectedTransport = _a.sent();
                            _a.label = 6;
                        case 6:
                            selectedTransport.setExchangeTimeout(exchangeTimeout);
                            ledger = new LedgerProxy(exchangeTimeout, selectedTransport);
                            return [2 /*return*/];
                    }
                });
            });
        }
        function discover(discoveryOptions) {
            return new Promise(function (resolve, reject) {
                var _pathIndexList = discoveryOptions.pathIndexList || [0, 1, 2, 3];
                var missingIndexs = [];
                // let alreadyDiscoveredIndexs = keyMap.map(a => a.index);
                _pathIndexList.forEach(function (index) {
                    var matchedIndex = keyMap.find(function (i) { return i.index === index; });
                    if (!matchedIndex) {
                        missingIndexs.push(index);
                    }
                });
                return ledger
                    .getPathKeys(missingIndexs)
                    .then(function (keysResult) {
                    //Merge the new key info with any previous lookups
                    keyMap = keyMap.concat.apply(keyMap, keysResult);
                    var xxx = keyMap.map(function (a) { return a.key; });
                    var discoveryInfo = {
                        keys: keyMap,
                        note: 'add any extra discoverable info here'
                    };
                    resolve(discoveryInfo);
                });
            });
        }
        function disconnect() {
            return Promise.resolve();
        }
        // Authentication
        function login(accountName, authorization, index, key) {
            return __awaiter(this, void 0, void 0, function () {
                var user;
                return __generator(this, function (_a) {
                    // Every time someone calls login we add to the list of account names + ledger index.
                    // Then when it comes time to sign, we'll look for the accountName + auth match and use that Index to sign the txn.
                    if (accountName && authorization && key && index != undefined) {
                        selectedIndexArray.push({ id: accountName + '@' + authorization, index: index });
                    }
                    else {
                        throw 'When calling the ledger login function: accountName, authorization, index and key must be supplied';
                    }
                    user = {
                        accountName: accountName,
                        permission: authorization,
                        publicKey: key
                    };
                    return [2 /*return*/, user];
                });
            });
        }
        function logout(accountName) {
            return Promise.resolve(true);
        }
        function signArbitrary(data, userMessage) {
            return new Promise(function (resolve, reject) {
                reject('not implemented');
            });
        }
        function makeSignatureProvider() {
            return {
                getAvailableKeys: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var arr;
                        return __generator(this, function (_a) {
                            arr = keyMap.map(function (a) { return a.key; });
                            return [2 /*return*/, arr];
                        });
                    });
                },
                sign: function (signatureProviderArgs) {
                    return __awaiter(this, void 0, void 0, function () {
                        var rpc, args, api, _txn, ledgerManager, ledgerBuffer, signature, signatureArray, respone;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    rpc = new JsonRpc(network.protocol + '://' + network.host + ':' + network.port);
                                    args = {
                                        rpc: rpc,
                                        authorityProvider: undefined,
                                        abiProvider: undefined,
                                        signatureProvider: this,
                                        chainId: undefined,
                                        textEncoder: undefined,
                                        textDecoder: undefined
                                    };
                                    api = new Api(args);
                                    return [4 /*yield*/, api.deserializeTransactionWithActions(signatureProviderArgs.serializedTransaction)];
                                case 1:
                                    _txn = _a.sent();
                                    ledgerManager = new LedgerDataManager();
                                    return [4 /*yield*/, ledgerManager.serialize(signatureProviderArgs.chainId, _txn, api.abiTypes, api)];
                                case 2:
                                    ledgerBuffer = _a.sent();
                                    // console.log("ledgerBuffer");
                                    // console.log(ledgerBuffer);
                                    // let ledger = new LedgerProxy(exchangeTimeout, transport);
                                    // console.log(_txn);
                                    // console.log(selectedIndexArray);
                                    // We need to look into the transaction to see which accounts and permissions are trying to sign.
                                    // Then we try to find out which index that is on the ledger.
                                    // There is a small chance that there are multiple matches. This logic will match the last one. I can't think of a case where this would happen though.
                                    if (_txn.actions) {
                                        _txn.actions.forEach(function (action) {
                                            action.authorization.forEach(function (authorization) {
                                                var m = selectedIndexArray.find(function (x) {
                                                    var matchStr = authorization.actor + '@' + authorization.permission;
                                                    return x.id === matchStr;
                                                });
                                                if (m) {
                                                    selectedIndex = m.index;
                                                    // console.log('match in loop: ' + m.index);
                                                }
                                            });
                                        });
                                    }
                                    else {
                                        throw 'The transaciton does not contain any actions. Possible bug in eos-transit-ledger-provider';
                                    }
                                    if (selectedIndex == -1) {
                                        throw 'eos-transit-ledger-provider was unable to determine which index to use for the signature. Check that login() was called with the account that is now required to sign the transaction';
                                    }
                                    console.log('selectedIndex: ' + selectedIndex);
                                    return [4 /*yield*/, ledger.sign(ledgerBuffer, selectedIndex)];
                                case 3:
                                    signature = _a.sent();
                                    signatureArray = [signature];
                                    respone = {
                                        signatures: signatureArray,
                                        serializedTransaction: signatureProviderArgs.serializedTransaction
                                    };
                                    console.log(respone);
                                    return [2 /*return*/, respone];
                            }
                        });
                    });
                }
            };
        }
        var walletProvider = {
            id: id,
            meta: {
                name: name,
                shortName: shortName,
                description: description
            },
            signatureProvider: makeSignatureProvider(),
            connect: connect,
            discover: discover,
            disconnect: disconnect,
            login: login,
            logout: logout,
            signArbitrary: signArbitrary
        };
        return walletProvider;
    };
}
export default ledgerWalletProvider;
//# sourceMappingURL=index.js.map